import { Component, inject, Input } from '@angular/core'
import { MatProgressSpinner } from '@angular/material/progress-spinner'
import { PcStatusOverlayService } from '@shared/services/pc-status-overlay/pc-status-overlay.service'
import { Subject } from 'rxjs'
import { MapOverlayConfigPipe } from '../../pipes/pc-status-overlay.pipe'
import { PCButtonComponent } from '../buttons/pc-button/pc-button.component'
import { PcIconComponent } from '../pc-icon/pc-icon.component'
import { PCOverlayComponent } from '../pc-overlay/pc-overlay.component'

export interface PCStatusOverlayConfig {
  type: 'success' | 'error' | 'warning' | 'spinner'
  message: string
  title?: string
  closeable?: boolean
  primaryAction?: { text: string; verifiable: boolean; execute$: Subject<any> }
  secondaryAction?: { text: string; verifiable: boolean; execute$: Subject<any> }
  extraInfo?: string
  onCloseRoute?: string
  closeEvent$?: Subject<null>
  timeout?: number
  preventAutoClose?: boolean
  onCloseCallback?: () => void
}

@Component({
  selector: 'pc-status-overlay',
  templateUrl: './pc-status-overlay.component.html',
  styleUrls: ['./pc-status-overlay.component.scss'],
  imports: [PCOverlayComponent, MatProgressSpinner, PCButtonComponent, MapOverlayConfigPipe, PcIconComponent],
})
export class PCStatusOverlayComponent {
  @Input() small: boolean = false

  public overlayService = inject(PcStatusOverlayService)

  triggerPrimaryAction($event: any) {
    this.overlayService.config?.primaryAction?.execute$.next($event)
  }

  triggerSecondaryAction($event: any) {
    this.overlayService.config?.secondaryAction?.execute$.next($event)
  }

  triggerCloseAction() {
    if (this.overlayService.config?.closeEvent$) {
      this.overlayService.config.closeEvent$.next(null)
    } else {
      this.overlayService.closeStatus()
    }
    if (this.overlayService.config?.onCloseCallback) {
      this.overlayService.config.onCloseCallback()
    }
  }
}
